import {
    FETCH_USER_VALIDITY
} from '../actions/types';

const initialState = {
    item: {}
}

export default function(state=initialState, action) {
    switch(action.type) {
        case FETCH_USER_VALIDITY:
            return {
                ...state,
                item: action.payload
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/validityReducer.js